import { render, staticRenderFns } from "./output_price.vue?vue&type=template&id=58d94c1e&scoped=true"
import script from "./output_price.vue?vue&type=script&lang=js"
export * from "./output_price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d94c1e",
  null
  
)

export default component.exports